const Menu = {
    init() {
        window.addEventListener(
            'scroll', function (e) {
                if (window.scrollY > 0) {
                    $('#main-header').addClass('underlined');
                } else {
                    $('#main-header').removeClass('underlined');
                }
            }
        );
    },
};
export default Menu;
